import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const backgroundColor = [
    "#1E3A8A", // Azul oscuro
    "#065F46", // Verde oscuro
    "#0D9488", // Turquesa oscuro
    "#F97316", // Naranja vibrante
    "#2563EB", // Azul vibrante
    "#047857", // Verde esmeralda
    "#14B8A6", // Turquesa medio
    "#FB923C", // Naranja medio
    "#3B82F6", // Azul claro
    "#059669", // Verde medio
    "#2DD4BF", // Turquesa claro
    "#FCD34D", // Naranja ámbar
    "#60A5FA", // Azul suave
    "#34D399", // Verde claro
    "#5EEAD4", // Turquesa suave
    "#FEF3C7", // Naranja muy claro
    "#93C5FD", // Azul muy claro
    "#6EE7B7", // Verde menta
    "#99F6E4"  // Turquesa muy claro
]


const parseEuropeanNumber = (str) => {
    if (typeof str === 'string') {
        return parseFloat(str.replace(/\./g, '').replace(',', '.'));
    }
    return str;
};

const formatShortNumber = (num) => {
    if (num === undefined)
        num = 0;
    if (num < 0)
        num = num * -1;
    if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(2) + 'MM';
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(2) + 'M';
    if (num >= 1_000) return (num / 1_000).toFixed(2) + 'K';
    return num.toFixed(2);
};

const createCenterTextPlugin = (valueStr) => {
    const value = parseEuropeanNumber(valueStr);
    const formatted = formatShortNumber(value);

    return {
        id: `centerText-${valueStr}`,
        beforeDraw(chart) {
            const { width, height, ctx } = chart;
            ctx.save();

            const fontSize = (height / 70).toFixed(2);
            ctx.font = `${fontSize}em Satoshi-Variable`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = Number(value) < 0 ? 'rgb(255,0,0)' : '#000';

            ctx.fillText((Number(value) < 0 ? '-' : '') + formatted, width / 2, height / 2);
            ctx.restore();
        },
    };
};

const options = {
    cutout: '80%',
    plugins: {
        legend: {
            position: 'bottom',
            align: 'start',
            display: false,
            labels: {
                generateLabels: function (chart) {
                    const data = chart.data || {};
                    const datasets = data.datasets || [];
                    const labels = data.labels || [];

                    if (labels.length && datasets.length) {
                        return labels.map((label, index) => {
                            const dataset = datasets[0];
                            const value = dataset.data[index] || 0;
                            const borderColor = dataset.borderColor ? dataset.borderColor[index] : '#000';
                            return {
                                text: `${label}: ${value}%`,
                                fillStyle: dataset.backgroundColor[index],
                                strokeStyle: borderColor,
                                lineWidth: 2,
                                hidden: isNaN(value) || dataset.hidden,
                                index: index
                            };
                        });
                    }
                    return [];
                }
            }
        },

        tooltip: {
            callbacks: {
                label: function (context) {
                    const dataset = context.dataset;
                    const value = context.parsed;
                    const total = dataset.data.reduce((sum, val) => Number(sum) + Number(val), 0);

                    const percentage = ((value / total) * 100).toFixed(2);

                    return `${context.formattedValue} (${percentage}%)`;

                }
            }
        },
    },
};

const doughnut = ({ subtotalesCards, tot }) => {
    let names = [];
    let importes = []
    let color = [];
    console.log('tot-> ' + tot)
    for (let i = 0; i < subtotalesCards.length; i++) {
        names.push(subtotalesCards[i].subtotal);
        importes.push(subtotalesCards[i].importe);
        color.push(backgroundColor[i]);
    }

    let data = {
        labels: names,
        datasets: [
            {
                data: importes,
                backgroundColor: color
            },
        ],
    };

    return (
        <div style={{ display: 'flex' }}>
            {Number(tot) !== 0 && (
                <Doughnut
                    key={`chart-${tot}`} data={data} options={options} plugins={[createCenterTextPlugin(tot)]}
                />
            )}
        </div>
    )
}

export default doughnut;